import { AudioTalePreviewData, ImagesTalePreviewData, TaleType, TextTalePreviewData } from '../types';
import { TaleProps } from '../components/TalesList';


type GetFieldsForTalePreview = (type: TaleType) => (params: TextTalePreviewData | ImagesTalePreviewData | AudioTalePreviewData) => TaleProps;

export const getFieldsForTalePreview: GetFieldsForTalePreview = (type) => ({description, name, slug}) => ({name, slug, description, type})
